export const nonOrganizationUser = 1
export const organizationalUser = 10
export const adminUser = 100
export const superAdminUser = 1000
